import React, { Component } from 'react';
import styled from 'styled-components';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { toast } from 'react-toastify';
import { SendPromoCode } from '../../../services/apiServices';


const Container = styled.div`
  display: flex;
  width: 75%;
  flex-direction: column;
`;

const FormControlStyled = styled(FormControl)`
  background: #eee;
  width: 75%;
`;

const SubmitButton = styled(Button)`
  margin-top: 10px;
  display: flex;
`;

export default class Body extends Component {
  constructor() {
    super();
    this.state = {
      email: '',
      promoCode: '',
    };
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { email, promoCode } = this.state;
    try {
      const data = {
        email: email,
        promocode: promoCode,
      };

      const res = await SendPromoCode(data)
      toast.success(`${res?.message}.`);
      this.setState({
        email: '',
        promoCode: '',
      });
    } catch (error) {
      toast.error(error);
    }
  };

  render() {
    const { email, promoCode } = this.state;
    const isSubmitDisabled = !email || !promoCode;
    return (
      <Container>
        <form onSubmit={this.handleSubmit}>
          <TextField
            id="email"
            name="email"
            value={email}
            onChange={this.handleChange}
            type='email'
            label="User Email"
            variant="outlined"
            fullWidth
            placeholder="Enter User Email"
          />
          <TextField
            id="promo-code"
            name="promoCode"
            value={promoCode}
            onChange={this.handleChange}
            label="Promo Code"
            variant="outlined"
            fullWidth
            placeholder="Enter promo code"
            style={{ marginTop: '20px' }}
          />
          <SubmitButton type="submit" variant="contained" color="primary" disabled={isSubmitDisabled}>
            Submit Promo Code
          </SubmitButton>
        </form>
      </Container>
    );
  }
}
